/* Elevana bag: drawer + /cart page behaviour.
   The HTML always comes from Liquid: every cart call asks Shopify to re-render the
   drawer section (and the cart page section when we're on /cart) in the same request,
   via the Section Rendering API, then swaps it in. No prices are computed here.

   window.ElevanaCart.add(items, label) -> items: [{id, quantity}], opens the bag
   window.ElevanaCart.open() / .close() / .refresh()                              */
(function () {
  var DRAWER = 'elevana-cart-drawer';
  var root = document.getElementById('elc');
  if (!root) return;
  var lastFocus = null;

  /* Package protection (Sep 15, not optional since Sep 17): a hidden fee product, one line per bag,
     priced at about 5% of everything else. snippets/elevana-protection-state picks the right "Coverage"
     tier and prints it on #elc-inner (data-prot-ok / -want / -keys); whenever the bag's protection line
     isn't exactly that tier (missing, doubled, stale price, or left alone in an otherwise empty bag) we
     swap it. The "Disclaimer" property is what checkout shows under the line. */
  var PROT_HANDLE = root.getAttribute('data-prot-handle') || '';
  var PROT_NOTE = root.getAttribute('data-prot-note') || '';
  var protBusy = false, protTries = 0;
  function isProt(i) { return !!PROT_HANDLE && i.handle === PROT_HANDLE; }
  function protState() {
    var inner = document.getElementById('elc-inner');
    if (!PROT_HANDLE || !inner || !inner.hasAttribute('data-prot-ok')) return null;
    return {
      ok: inner.getAttribute('data-prot-ok') === '1',
      want: parseInt(inner.getAttribute('data-prot-want'), 10) || 0,
      keys: (inner.getAttribute('data-prot-keys') || '').split(',').filter(Boolean)
    };
  }
  function syncProt() {
    var s = protState();
    if (!s || protBusy) return Promise.resolve();
    if (s.ok) { protTries = 0; return Promise.resolve(); }
    if (protTries >= 3) return Promise.resolve();    /* don't loop forever if Shopify keeps refusing */
    protTries++;
    protBusy = true;
    var drop = {};
    s.keys.forEach(function (k) { drop[k] = 0; });
    return (s.keys.length ? post('/cart/update.js', { updates: drop }) : Promise.resolve(null))
      .then(function (j) {
        if (!s.want) return j;
        return post('/cart/add.js', { items: [{ id: s.want, quantity: 1, properties: { Disclaimer: PROT_NOTE } }] });
      })
      .then(function (j) { if (j) swap(j.sections); })
      .catch(function () { return refresh().catch(function () {}); })
      .finally(function () { protBusy = false; })
      .then(syncProt);
  }

  /* checkout: re-read the bag and settle its protection line before Shopify takes over */
  function checkoutUrl() { return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout'; }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!PROT_HANDLE || !f.closest || !f.closest('#elc, #elc-page') || !f.querySelector('[name="checkout"]')) return;
    e.preventDefault();
    if (e.submitter) e.submitter.disabled = true;
    busy(true);
    protTries = 0;
    refresh().then(syncProt).catch(function () {}).then(function () { window.location.href = checkoutUrl(); });
  });

  function pageEl() { return document.getElementById('elc-page'); }
  function sectionIds() {
    var ids = [DRAWER], p = pageEl();
    if (p && p.dataset.section) ids.push(p.dataset.section);
    return ids;
  }

  function swap(sections) {
    if (!sections) return;
    var doc, fresh;
    if (sections[DRAWER]) {
      doc = new DOMParser().parseFromString(sections[DRAWER], 'text/html');
      fresh = doc.getElementById('elc-inner');
      var cur = document.getElementById('elc-inner');
      if (fresh && cur) cur.replaceWith(fresh);
    }
    var p = pageEl();
    if (p && sections[p.dataset.section]) {
      doc = new DOMParser().parseFromString(sections[p.dataset.section], 'text/html');
      fresh = doc.getElementById('elc-page');
      if (fresh) p.replaceWith(fresh);
    }
    syncCount();
    setTimeout(syncProt, 0);
  }

  function syncCount() {
    var inner = document.getElementById('elc-inner');
    var n = inner ? parseInt(inner.getAttribute('data-count'), 10) || 0 : 0;
    document.querySelectorAll('.cart-n').forEach(function (b) { b.textContent = n; });
    document.querySelectorAll('[data-elc-open]').forEach(function (b) {
      b.setAttribute('aria-label', 'Bag, ' + n + (n === 1 ? ' item' : ' items'));
    });
  }

  function post(url, body) {
    body.sections = sectionIds().join(',');
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || 'Something went wrong'); e.status = r.status; throw e; }
        return j;
      });
    });
  }

  function busy(on) { root.classList.toggle('is-busy', !!on); }

  function note(msg, isErr) {
    var el = root.querySelector('.elc-added');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('is-err', !!isErr);
    el.hidden = false;
  }

  function open() {
    if (!root.classList.contains('is-open')) {
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('elc-lock');
      var panel = root.querySelector('.elc-panel');
      if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 60);
    }
    syncProt();
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('elc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function refresh() {
    return fetch(window.location.pathname + '?sections=' + sectionIds().join(','))
      .then(function (r) { return r.json(); }).then(swap);
  }

  /* Cart deal: keep its discount code on the cart next to any other code (BOGO codes included). */
  function cartCodes(cart) { return (cart.discount_codes || []).map(function (c) { return c.code; }); }
  function setCodes(list) {
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: list.join(',') }) })
      .then(function (r) { return r.json(); });
  }
  function offerCode(code, on) {
    if (!code) return Promise.resolve();
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var codes = cartCodes(cart), has = codes.some(function (c) { return c.toUpperCase() === code.toUpperCase(); });
      if (on === has) return;
      var next = on ? codes.concat([code]) : codes.filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
      return setCodes(next).then(refresh);
    });
  }
  function offerCleanup() {
    var code = root && root.dataset.offerCode;
    if (!code) return;
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var items = cart.items || [];
      var deal = items.filter(function (i) { return i.properties && i.properties._offer; })[0];
      if (!deal) return offerCode(code, false);
      var qualifies = items.some(function (i) { var p = i.properties || {}; return !p._offer && !p._bogo && !isProt(i) && i.product_id !== deal.product_id; });
      if (!qualifies) {
        return post('/cart/change.js', { id: deal.key, quantity: 0 }).then(function (j) { swap(j.sections); return offerCode(code, false); })
          .then(function () { note('The Blue Razz deal needs another item in your bag, so it was removed.', true); });
      }
    }).catch(function () {});
  }

  /* items: [{id, quantity}] */
  function add(items, label) {
    busy(true);
    protTries = 0;
    return post('/cart/add.js', { items: items })
      .then(function (j) {
        swap(j.sections);
        var first = j.items && j.items[0];
        var what = label || (first ? first.product_title + (first.variant_title ? ' · ' + first.variant_title : '') : 'Item');
        note(what + ' added to your bag');
        open();
        return j;
      })
      .catch(function (e) {
        return refresh().then(function () {
          note(e.status === 422 ? e.message : 'Could not add that. Please try again.', true);
          open();
          throw e;
        });
      })
      .finally(function () { busy(false); });
  }

  function change(key, qty) {
    busy(true);
    protTries = 0;
    return post('/cart/change.js', { id: key, quantity: qty })
      .then(function (j) { swap(j.sections); document.dispatchEvent(new CustomEvent('elevana:cart-changed')); return syncProt().then(offerCleanup); })
      .catch(function (e) { return refresh().then(function () { note(e.message, true); }); })
      .finally(function () { busy(false); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-elc-open],[data-elc-close],[data-elc-qty],[data-elc-add],[data-elo-add]');
    if (!t) return;
    if (t.hasAttribute('data-elc-open')) {
      if (pageEl()) return;                 /* already on /cart: follow the link */
      e.preventDefault(); open(); return;
    }
    if (t.hasAttribute('data-elc-close')) { e.preventDefault(); close(); return; }
    if (t.hasAttribute('data-elc-qty')) {
      var line = t.closest('[data-key]');
      if (line) { e.preventDefault(); change(line.getAttribute('data-key'), Math.max(0, parseInt(t.getAttribute('data-elc-qty'), 10) || 0)); }
      return;
    }
    if (t.hasAttribute('data-elo-add')) {
      e.preventDefault();
      if (t.disabled) return;
      t.disabled = true;
      var code = t.getAttribute('data-elo-code');
      add([{ id: parseInt(t.getAttribute('data-elo-add'), 10), quantity: 1, properties: { _offer: code } }], 'Deal added')
        .then(function () { return offerCode(code, true); })
        .catch(function () {});
      return;
    }
    if (t.hasAttribute('data-elc-add')) {
      e.preventDefault();
      add([{ id: parseInt(t.getAttribute('data-elc-add'), 10), quantity: 1 }]).catch(function () {});
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  /* order note on /cart, saved as you type (debounced) */
  var noteT;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-elc-note]')) return;
    clearTimeout(noteT);
    var v = e.target.value;
    noteT = setTimeout(function () {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) });
    }, 500);
  });

  /* back/forward cache can restore a stale bag */
  window.addEventListener('pageshow', function (e) { if (e.persisted) { busy(false); refresh(); } });

  window.ElevanaCart = { add: add, open: open, close: close, refresh: refresh, change: change, note: note };
  syncCount();
  syncProt();
})();
